const FONT_FAMILY_TYPE = "fontFamily";
export {
  FONT_FAMILY_TYPE
};
//# sourceMappingURL=types.js.map
